export const MY_BOOKINGS_ROUTE_KEYS = {
  MY_BOOKINGS_LIST: "bookings",
};

export const MY_BOOKINGS_ROUTE_IDS = {
  [MY_BOOKINGS_ROUTE_KEYS.MY_BOOKINGS_LIST]: "my-bookings",
};
